import React, { useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
} from "recharts";

export default function WaterfallRecharts({ totalizadorWaterfall }) {

  const [data,setData] = React.useState([]);

  useEffect(() => {
    setData([
      {
        name: "RECEITA BRUTA",
        R$: totalizadorWaterfall.totalReceitaBruta, // uv is the part of the graph we want to show
        pv: 0 // pv is the floating part (transparent)
      },
      {
        name: "IMPOSTO",
        R$: -totalizadorWaterfall.totalImposto,
        pv: totalizadorWaterfall.totalReceitaBruta // to get this pv, we use 01/2020's uv + pv
      },
      {
        name: "RECEITA LÍQUIDA",
        R$: totalizadorWaterfall.totalReceitaLiquida,
        pv: 0 // use 02/2020's uv + pv, and so forth
      },
      {
        name: "CMV",
        R$: -totalizadorWaterfall.totalCmv,
        pv: totalizadorWaterfall.totalReceitaLiquida
      },
      {
        name: "RECEITA OPERAC.",
        R$: totalizadorWaterfall.totalReceitaOperacional,
        pv: 0
      },
      {
        name: "DESPESA",
        R$: -totalizadorWaterfall.totalDespesa,
        pv: totalizadorWaterfall.totalReceitaOperacional
      },
      {
        name: "EBITDA",
        percentualEbtida: totalizadorWaterfall.percentualEbitda,
        R$: totalizadorWaterfall.totalEbitda,
        pv: 0
      }
    ])
}, [totalizadorWaterfall]);

  return (
    <div>
       <div style={{position:'absolute', right:100, top:0, zIndex:200, textAlign: 'center'}}>
            <h6>% EBITDA
            <br/>
            {totalizadorWaterfall && totalizadorWaterfall.percentualEbitda != undefined ? totalizadorWaterfall.percentualEbitda : 0} %
            </h6>
        </div>
    <ResponsiveContainer width='99%' height={400}>
         <BarChart
            width={1200}
            height={400}
            data={data}
            margin={{
              top: 2,
              right: 30,
              left: 20,
              bottom: 35
            }}
          >
            <Tooltip formatter={(valor) => new Intl.NumberFormat('pt').format(valor)} />
            <XAxis dataKey="name" />
            <Tooltip />
            <Bar dataKey="R$" stackId="a" fill="#343a40"  >
              <LabelList 
                dataKey="R$" 
                fill="#000" 
                formatter={(x) => `R$ ${new Intl.NumberFormat('pt').format(x)}`}
                position="inside"
               />
              {data.map((item, index) => {
                if (item.R$ < 0) 
                  return <Cell key={index} fill="#E8C2C2" />;
                else
                  return <Cell key={index} fill="#9BB2DB" />;
              })}
            </Bar>
          </BarChart>
      </ResponsiveContainer>
        
        </div>
  );

}